import { FRAME_ID } from 'verify/components/Application/Frame';

/**
 * https://kittygiraudel.com/2020/01/15/accessible-title-in-a-single-page-react-application/
 *
 * On route change, try to focus a meaningful element for screen readers.
 * If a Title UI component is present, focus that. Else, focus on the Inquiry frame itself.
 */
export function focusTitleElement(root?: HTMLElement | null) {
  // Default to Inquiry flow frame
  root ??= document.getElementById(FRAME_ID);

  const focusTarget = root?.querySelector('h1') ?? root;

  const isVisible = focusTarget?.offsetParent != null;

  if (isVisible) {
    focusTarget?.focus();
  }
}
